import { Route, Routes } from "react-router-dom";
import Patients from "./pages/Patients";
import PatientEdit from "./pages/PatientEdit";
import PatientAdd from "./pages/PatientAdd";
import Patient from "./pages/Patient";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Patients />} />
        <Route path="/patient" element={<PatientAdd />} />
        <Route path="/patient-edit/:id" element={<PatientEdit />} />
        <Route path="/patient/:id" element={<Patient />} />
      </Routes>
    </div>
  );
}

export default App;
